import React from 'react';
import LegalPage from './LegalPage';
import { ScrollText } from 'lucide-react';

const TermsPage = () => {
  return (
    <LegalPage 
      title="Allgemeine Geschäftsbedingungen (AGB)" 
      contentKey="legal_terms"
      icon={ScrollText}
    />
  );
};

export default TermsPage;
